module.exports = __webpack_public_path__ + "static/media/webscape_24_round-1.a0a60cd6.jpg";